import React from 'react';

import { ColumnDef } from '@/components/elements/table/types';
import useTableFilters from '@/hooks/useTableFilters';
import GenericTableWithData from '@/modules/dataFetching/components/GenericTableWithData';
import RelativeDateTableCellContents from '@/modules/hmis/components/RelativeDateTableCellContents';
import {
  ClientAccessSummaryFieldsFragment,
  GetUserClientSummariesDocument,
  GetUserClientSummariesQuery,
  GetUserClientSummariesQueryVariables,
} from '@/types/gqlTypes';

const columns: ColumnDef<ClientAccessSummaryFieldsFragment>[] = [
  {
    header: 'Client Name',
    render: 'clientName',
    key: 'name',
  },
  {
    header: 'Client ID',
    render: 'clientId',
    key: 'id',
  },
  {
    header: 'Last Accessed',
    key: 'lastAccessed',
    render: ({ lastAccessedAt }) => (
      <RelativeDateTableCellContents
        dateTimeString={lastAccessedAt}
        horizontal
      />
    ),
  },
];

interface Props {
  userId: string;
  searchTerm?: string;
}
const ClientAccessSummaryTable: React.FC<Props> = ({
  userId,
  searchTerm = '',
}) => {
  const { filters, filterValues, setFilterValues } = useTableFilters({
    type: 'ClientAccessSummaryFilterOptions',
  });

  return (
    <GenericTableWithData<
      GetUserClientSummariesQuery,
      GetUserClientSummariesQueryVariables,
      ClientAccessSummaryFieldsFragment
    >
      queryVariables={{
        id: userId,
        filters: { searchTerm },
      }}
      queryDocument={GetUserClientSummariesDocument}
      columns={columns}
      pagePath='user.clientAccessSummaries'
      noData='No access history'
      paginationItemName='accessed client'
      recordType='ClientAccessSummary'
      filters={filters}
      filterValues={filterValues}
      onFilterChange={setFilterValues}
    />
  );
};

export default ClientAccessSummaryTable;
